var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.01 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-menu-2",
    className: "cls-1",
    d: "M.62,0A.57.57,0,0,0,.51,1.13S.58,1.13.62,1H15.39A.42.42,0,0,0,16,.62.57.57,0,0,0,15.49,0H.62Zm0,4A.49.49,0,0,0,0,4.45a.56.56,0,0,0,.51.61S.58,5.07.62,5H15.39A.48.48,0,0,0,16,4.56a.56.56,0,0,0-.51-.62.09.09,0,0,0-.1.06Zm0,4A.43.43,0,0,0,0,8.39.56.56,0,0,0,.51,9H15.39a.56.56,0,1,0,.1-1.12s-.07,0-.1.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideShow);
export default __webpack_public_path__ + "static/media/hide_show.2998fe5e9e4a49c0e3b51c03ef3aca6c.svg";
export { ForwardRef as ReactComponent };